import { FC } from 'react'
import { useWallet } from '@solana/wallet-adapter-react'
import { Grid, Paper, styled } from '@mui/material'
import { Wallet } from '../Wallet/Wallet'
import { LoanList } from '../LoanList/LoanList'
import { useSelector } from 'react-redux'
import { getSelectedTab } from '../../redux/modules/app'
import Tabs from './Tabs'
import { Arbitrage } from '../Arbitrage/Arbitrage'

interface TabPanelProps {
  children?: React.ReactNode
  dir?: string
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <br />
      {value === index && children}
    </div>
  )
}

export const MainBox: FC = () => {
  const { publicKey } = useWallet()
  const selectedTab = useSelector(getSelectedTab)

  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))

  return (
    <Grid
      container
      spacing={2}
      columns={16}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Item className={'App-center-box'}>
          {publicKey ? (
            <div>
              <Tabs />
              <TabPanel value={selectedTab} index={0}>
                <LoanList />
              </TabPanel>
              <TabPanel value={selectedTab} index={1}>
                <Arbitrage />
              </TabPanel>
            </div>
          ) : (
            <div className="Wallet-button-div-middle">
              <Wallet />
            </div>
          )}
        </Item>
      </Grid>
    </Grid>
  )
}
